'use client';

// Composition des fournisseurs client (thème, i18n, cache API).
// Monté une seule fois dans le layout racine, sous <html>.

import type { ReactNode } from 'react';

import { I18nProvider } from '@/i18n/I18nProvider';
import { QueryProvider } from '@/lib/query/QueryProvider';
import { ThemeProvider } from '@/lib/theme/ThemeProvider';

export function Providers({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider>
      <I18nProvider>
        <QueryProvider>{children}</QueryProvider>
      </I18nProvider>
    </ThemeProvider>
  );
}
